export const cacheService = (minutes = 60) => ({
  staleTime: minutes * 60 * 1000,
  refetchOnWindowFocus: false,
});
